import {
  SubscriptionVariantID,
  UserSubscriptionsData,
} from '@shared/types/common';
import { makeTextCamelcase } from './textFormat';
import moment from 'moment';

export const isSubscriptionRestricted = (firstTermination: string) => {
  const hasFirstTerminationDate = !!firstTermination;

  const todaysDate = moment().startOf('day');
  const terminationDate = moment(firstTermination).startOf('day');

  const isTerminationDateBeforeToday = terminationDate.isBefore(todaysDate);

  const isRestricted = hasFirstTerminationDate && !isTerminationDateBeforeToday;
  return isRestricted;
};

export const isMarketingSubscriptionActive = (
  subscriptionData: UserSubscriptionsData[]
) => {
  const marketingSubscription = subscriptionData?.find(
    ({ id }) =>
      id === SubscriptionVariantID.MARKETING_PROD ||
      id === SubscriptionVariantID.MARKETING_STAGING
  );

  const isMarketingConsentActive = marketingSubscription?.isActive || false;

  return isMarketingConsentActive;
};
